import { useAppStore } from '@/shared/infrastructure/composition/useAppStore';
import { APPLICATION_TYPES } from '@hfc/common';
import { CoverageResponse, SfApiResponse } from '@hfc/ui-core';

interface UseCheckCoverageInterface {
  checkCoverage: (applicationType: APPLICATION_TYPES, zipCode: number) => Promise<SfApiResponse<CoverageResponse>>;
}

export function useCheckCoverage (): UseCheckCoverageInterface {
  const { appStore } = useAppStore();

  const checkCoverage = async (applicationType: APPLICATION_TYPES, zipCode: number): Promise<SfApiResponse<CoverageResponse>> => {
    return await appStore.checkCoverage(applicationType, zipCode);
  };

  return {
    checkCoverage
  };
}
